// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrophyFilledSvg from "@fishx/icons-svg/es/asn/TrophyFilled";
import FishxIcon from '../components/FishxIcon';

var TrophyFilled = function TrophyFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrophyFilledSvg
  }));
};

TrophyFilled.displayName = 'TrophyFilled';
export default React.forwardRef(TrophyFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrophyFilled.js
// module id = 4285
// module chunks = 0